import { useCallback, useEffect, useState } from "react";
import {
	applyThemePreference,
	persistTheme,
	readStoredTheme,
	type ThemePreference,
} from "../lib/theme";

/**
 * Theme preference (light | dark | system) with localStorage persistence
 * and prefers-color-scheme follow when preference is system.
 */
export function useTheme() {
	const [preference, setPreferenceState] = useState<ThemePreference>(() =>
		typeof window !== "undefined" ? readStoredTheme() : "system",
	);

	useEffect(() => {
		applyThemePreference(preference);
		persistTheme(preference);
	}, [preference]);

	useEffect(() => {
		if (preference !== "system") return;
		const mq = window.matchMedia("(prefers-color-scheme: dark)");
		const onChange = () => {
			applyThemePreference("system");
		};
		mq.addEventListener("change", onChange);
		return () => mq.removeEventListener("change", onChange);
	}, [preference]);

	const setPreference = useCallback((next: ThemePreference) => {
		setPreferenceState(next);
	}, []);

	return { preference, setPreference };
}
